import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import XplorerTable from '@blade-sxp/pass/components/xplorer-table.vue';
import { EType } from '@blade/common/interfaces/user-group';
import { StaffModule } from '@blade-sxp/pass/store/staff';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import { handleError } from '@blade/common/utils/handle-error';
let default_1 = class extends Vue {
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    whiteStaff = [];
    params = {
        dateEnd: '',
        dateStart: '',
        keywords: '',
        sort: 'DESC',
        userGroup: EType.USER,
    };
    listLoading = false;
    handleSizeChange(size) {
        this.pagination.size = size;
        this.pagination.page = 1;
        this.getData();
    }
    handleCurrentChange(curr) {
        console.log('curr:', curr);
        this.pagination.page = curr;
        this.getData();
    }
    handleFullScreen() {
        const isFullScreen = !!document.fullscreenElement;
        if (isFullScreen)
            document.exitFullscreen();
        else
            document.body.requestFullscreen();
        // this.fullscreen = !isFullScreen;
    }
    handleRefresh() {
        this.getData();
    }
    handleCreate() {
        this.$router.push('/users/portraitmanagement/pass/create');
    }
    mounted() {
        console.log('mounted');
        this.getData();
    }
    async getData() {
        this.listLoading = true;
        try {
            const res = await StaffModule.getStaffs({ ...this.params, page: this.pagination.page, size: this.pagination.size });
            console.log('res:', res);
            const { list, total } = res.data;
            this.whiteStaff = list;
            this.pagination.total = total;
            this.listLoading = false;
        }
        catch (e) {
            this.listLoading = false;
        }
    }
    async handleSearch(search) {
        this.listLoading = true;
        try {
            const { keywords, ...rest } = this.params;
            const res = await StaffModule.getStaffs({ ...rest, keywords: search, page: 1, size: this.pagination.size });
            console.log('res:', res);
            const { list, total } = res.data;
            this.whiteStaff = list;
            this.pagination.total = total;
            this.pagination.page = 1;
            this.listLoading = false;
        }
        catch (e) {
            this.listLoading = false;
            handleError(e);
        }
    }
    handleEdit(row) {
        console.log('row:', row);
        this.$router.push(`/users/portraitmanagement/pass/${row.libId}`);
    }
    handleDelete(row) {
        if (row.currentSize > 0) {
            this.$alert('', this.$t('deleteT').toString(), {
                confirmButtonText: this.$t('confirm').toString(),
                message: this.$t('deleteW').toString(),
            });
        }
        else {
            this.$confirm(`${this.$t('delete').toString()}${row.name}?`, '', {
                confirmButtonText: this.$t('confirm').toString(),
                cancelButtonText: this.$t('cancel').toString(),
                type: 'warning',
            })
                .then(async () => {
                try {
                    await StaffModule.deleteStaff(row.libId);
                    this.$elmessage.success(this.$t('deleted').toString());
                    this.getData();
                }
                catch (error) {
                    handleError(error);
                }
            })
                .catch((error) => {
                console.log(error);
            });
        }
    }
    handleNameClick(row) {
        const { libId } = row;
        this.$emit('name-click', libId);
    }
    /**
     *@Description: 排序向后段发送请求
     *@Date: 2020-09-10 18:20:13
     */
    handleSortChange(column) {
        const sortMap = { descending: 'DESC', ascending: 'ASC' };
        const { order } = column;
        this.params.sort = sortMap[order] || 'DESC';
        this.getData();
    }
};
default_1 = __decorate([
    Component({
        name: 'portrait',
        components: { AuthItem, XplorerTable },
        i18n: {
            messages: {
                'en-us': {
                    group: 'Portrait Library Name',
                    count: 'Portrait Library Count',
                    ppl: 'Creator',
                    update: 'Update Time',
                    delete: 'Are you sure to delete ',
                    confirm: 'OK',
                    cancel: 'Cancel',
                    deleted: 'Delete successfully',
                    deleteW: 'Please deletes all Portrait first',
                    deleteT: 'To Delete',
                },
                zh: {
                    group: '人像库名称',
                    count: '人像数量',
                    ppl: '创建人',
                    update: '更新时间',
                    delete: '确认删除 ',
                    confirm: '确认',
                    cancel: '取消',
                    deleted: '成功删除',
                    deleteW: '请先删除组内人像',
                    deleteT: '全部删除',
                },
            },
        },
    })
], default_1);
export default default_1;
